/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseLoopingTickerFragment, LoopingTickerFragment, FullLoopingTickerFragment} from '@amblique/contentful/app/contentful/fragments/looping-ticker';

/**
 * Get a single LoopingTicker by ID (base - scalars only)
 */
export const getBaseLoopingTickerById = gql`
  ${BaseLoopingTickerFragment}

  query GetBaseLoopingTickerById($id: String!, $locale: String!, $preview: Boolean) {
    loopingTicker(id: $id, locale: $locale, preview: $preview) {
      ...BaseLoopingTickerFragment
    }
  }
`;

/**
 * Get a single LoopingTicker by ID (standard - 1 level deep)
 */
export const getLoopingTickerById = gql`
  ${LoopingTickerFragment}

  query GetLoopingTickerById($id: String!, $locale: String!, $preview: Boolean) {
    loopingTicker(id: $id, locale: $locale, preview: $preview) {
      ...LoopingTickerFragment
    }
  }
`;

/**
 * Get a single LoopingTicker by ID (full - 2 levels deep)
 */
export const getFullLoopingTickerById = gql`
  ${FullLoopingTickerFragment}

  query GetFullLoopingTickerById($id: String!, $locale: String!, $preview: Boolean) {
    loopingTicker(id: $id, locale: $locale, preview: $preview) {
      ...FullLoopingTickerFragment
    }
  }
`;

/**
 * Get all LoopingTicker entries with pagination (base - scalars only)
 */
export const getBaseLoopingTickers = gql`
  ${BaseLoopingTickerFragment}

  query GetBaseLoopingTickers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [LoopingTickerOrder]
    $where: LoopingTickerFilter
    $preview: Boolean
  ) {
    loopingTickerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseLoopingTickerFragment
      }
    }
  }
`;

/**
 * Get all LoopingTicker entries with pagination (standard - 1 level deep)
 */
export const getLoopingTickers = gql`
  ${LoopingTickerFragment}

  query GetLoopingTickers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [LoopingTickerOrder]
    $where: LoopingTickerFilter
    $preview: Boolean
  ) {
    loopingTickerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...LoopingTickerFragment
      }
    }
  }
`;

/**
 * Get all LoopingTicker entries with pagination (full - 2 levels deep)
 */
export const getFullLoopingTickers = gql`
  ${FullLoopingTickerFragment}

  query GetFullLoopingTickers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [LoopingTickerOrder]
    $where: LoopingTickerFilter
    $preview: Boolean
  ) {
    loopingTickerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullLoopingTickerFragment
      }
    }
  }
`;
